import React from "react";
import ProgressionService from "../data/services/ProgressionService";
import {TicketData} from "../data/entities/UserDataEntity";
import {UserProgressionInfoEntity} from "../data/entities/UserProgressionInfoEntity";
import {ProgressionLevelEntity} from "../data/entities/ProgressionLevelEntity";
import {subscriptionTypes} from "../data/entities/UserSubscriptionInfoEntity";

interface ProgressionContextData {
    displayProgression: boolean;
    isLoadingProgressionLevels: boolean;
    progressionLevels: ProgressionLevelEntity[];
    hasErrorProgressionLevels: boolean;
    refreshProgressionData: () => void;
}

export const ProgressionContext = React.createContext({
    displayProgression: false,
    progressionLevels: [],
    isLoadingUserProgression: true,
    isLoadingProgressionLevels: true,
    hasErrorUserProgressionLevel: false,
    hasErrorProgressionLevels: false,
    refreshProgressionData: () => {}
} as ProgressionContextData);

interface Props {
    userProgression: UserProgressionInfoEntity | null;
    validateUserCountry: (allowedCountries?: string) => boolean;
    validateProgressionType: (allowedProgressionTypes: string[]) => boolean;
    validateSubscriptionProgressionPrivilege: () => boolean;
    locale: string;
    ticketData: TicketData;
}

export default class ProgressionProvider extends React.Component<Props, ProgressionContextData> {
    refreshProgressionData = () => {
        this.setState({
            isLoadingProgressionLevels: true,
            progressionLevels: [],
            hasErrorProgressionLevels: false,
        }, this.loadUserProgressionWidgetData);
    };

    state: ProgressionContextData = {
        displayProgression: false,
        isLoadingProgressionLevels: true,
        progressionLevels: [],
        hasErrorProgressionLevels: false,
        refreshProgressionData: this.refreshProgressionData
    };

    componentDidMount(): void {
        this.validateDisplay();
    }

    loadUserProgressionWidgetData = () => {
        let {ticketData, locale} = this.props;

        if(ticketData.ticket) {
            this.getProgressionLevels(ticketData.ticket, locale);
        }
    };

    getProgressionLevels = (ticket: string, locale: string) => {
        ProgressionService.getProgressionLevels(ticket, locale)
            .then((response: any) => {
                this.setState({
                    progressionLevels: response.data,
                    isLoadingProgressionLevels: false
                });
            }).catch(error => {
                console.error('Request Error', error);
                this.setState({
                    hasErrorProgressionLevels: true,
                    isLoadingProgressionLevels: false
                });
            });
    };

    validateDisplay = () => {
        if (
            this.props.validateUserCountry(process.env.REACT_APP_COUNTRIES_PROGRESSION) &&
            this.props.validateProgressionType([subscriptionTypes.premium, subscriptionTypes.premiumAnywhere]) &&
            this.props.validateSubscriptionProgressionPrivilege()
        ) {
            this.setState({displayProgression: true}, () => {
                this.loadUserProgressionWidgetData();
            });
        }
    };

    render(): JSX.Element {
        return (
            <ProgressionContext.Provider value={this.state}>
                <React.Fragment>
                    {this.props.children}
                </React.Fragment>
            </ProgressionContext.Provider>
        );
    }
}